import { Filter } from 'components/molecules/filters/types';

export const getTemplateIdFromFilter = (
  filter?: Filter,
): number | undefined => {
  return (
    filter?.criteria.find(
      (criteria) => criteria.field.fieldName === 'template',
    ) as { value: number }
  )?.value;
};
